import Typography from "component-lib/Base/components/Typography"
import { makeStyles } from "tss-react/mui"
import { ReactSVG } from "react-svg"
import { useState } from "react"
import getContentUrl from "utils-lib/getContentUrl"
import { wmColor } from "themes-lib/wmTheme"
import { Link, Button } from "../../../Base"
import "./sevenCard.scss"

const useStyles = makeStyles()((theme, { contentPreviewCardsList }) => ({
  headingDisplay: {
    [theme.breakpoints.down(`sm`)]: {
      paddingLeft: `1rem`,
    },
  },
  headingLink: {
    "& a": {
      marginTop: `0 !important`,
      textDecoration: `none`,
    },
  },
  contentPreviewCard: {
    width: `346px !important`,
    minHeight: 1,
    maxHeight: 1000,
    height: `auto`,
    padding: `0 !important`,
    marginBottom: `20px`,
    position: `relative`,
    "& img": {
      height: 215,
      width: `100%`,
      marginBottom: 24,
    },
    [theme.breakpoints.down(`sm`)]: {
      display: `none`,
    },
    [theme.breakpoints.down(`md`)]: {
      flexBasis: `48.8%`,
      marginBottom: `32px`,
    },
  },
  contentDate: {
    [theme.breakpoints.down(`md`)]: {
      paddingBottom: `0`,
      lineHeight: `14px`,
      marginBottom: `8px`,
    },
  },
  contentCardBlock: {
    margin: `0 16px`,
  },
  contentDescription: {
    display:
      contentPreviewCardsList.contentPreviewCardsList.description.length > 200
        ? `inline`
        : `none`,
  },
  contentPreviewMobile: {
    display: `none`,
    [theme.breakpoints.down(`sm`)]: {
      display: `block`,
      width: `100%`,
    },
  },
}))

const ContentPreviewCard = (contentPreviewCardsList, collapse) => {
  const [isExpand, setIsExpand] = useState(false)
  const symbol = isExpand ? `minus` : `plus`

  const { classes } = useStyles({ contentPreviewCardsList })

  return (
    <>
      <div
        className={`cardWrapper  ${classes.contentPreviewCard} ${
          contentPreviewCardsList.contentPreviewCardsList.cardImage
            ? "contentcard"
            : ""
        }`}
        data-testid="ContentPreviewCard"
      >
        <img
          src={getContentUrl(
            contentPreviewCardsList.contentPreviewCardsList.image,
          )}
          alt={contentPreviewCardsList.contentPreviewCardsList.imageAltText}
        />
        <div className={`card-block ${classes.contentCardBlock}`}>
          <div
            className={`${
              contentPreviewCardsList.contentPreviewCardsList.cardImage
                ? "WmcontentcardwithImage"
                : "WmcontentcardwithoutImage"
            }`}
            style={{ marginBottom: `24px`, paddingBottom: `48px` }}
          >
            <div
              className={`maax-font-weight-bold cardItemtitle ${classes.contentDate}`}
              style={{ paddingBottom: `0` }}
            >
              {contentPreviewCardsList.contentPreviewCardsList.date}
            </div>
            <Typography
              className={`maax-font-weight-bold cardHeading ${classes.headingLink}`}
              variant="h4"
              style={{ color: "black" }}
            >
              <Link
                overrideClass="maax-font-weight-black cardHeading"
                href={contentPreviewCardsList.contentPreviewCardsList.ctaLink}
                isExternalLink={
                  contentPreviewCardsList.contentPreviewCardsList.isExternalLink
                }
                style={{
                  marginTop: `0`,
                  textDecoration: `none`,
                  fontSize: `unset`,
                }}
                analytics_key={
                  contentPreviewCardsList?.contentPreviewCardsList
                    ?.analyticsKey ||
                  `${contentPreviewCardsList.contentPreviewCardsList.cardHeading} ${contentPreviewCardsList.contentPreviewCardsList.cardCtaText} ${contentPreviewCardsList.contentPreviewCardsList.cardCtaURL}`
                }
              >
                {contentPreviewCardsList.contentPreviewCardsList.heading}
              </Link>
            </Typography>
            <div
              className="flex-grow-1 cardItemsubText maax-font-weight-regular"
              data-testid="cardDescription"
              style={{ marginTop: `8px` }}
            >
              {contentPreviewCardsList.contentPreviewCardsList.description.slice(
                0,
                200,
              )}
              <span className={`${classes.contentDescription}`}>...</span>
            </div>

            <Link
              overrideClass="maax-font-weight-regular"
              href={contentPreviewCardsList.contentPreviewCardsList.ctaLink}
              isExternalLink={
                contentPreviewCardsList.contentPreviewCardsList.isExternalLink
              }
              style={{
                marginBottom: `24px`,
                bottom: `0`,
                position: `absolute`,
              }}
              analytics_key={
                contentPreviewCardsList?.contentPreviewCardsList
                  ?.analyticsKey ||
                `${contentPreviewCardsList.contentPreviewCardsList.cardHeading} ${contentPreviewCardsList.contentPreviewCardsList.cardCtaText} ${contentPreviewCardsList.contentPreviewCardsList.cardCtaURL}`
              }
            >
              {contentPreviewCardsList.contentPreviewCardsList.ctaLinkText}
            </Link>
          </div>
        </div>
      </div>

      {collapse ? (
        <div className={`${classes.contentPreviewMobile}`}>
          <div
            {...{
              className: `accordion-item accordion-item--${
                isExpand ? `opened` : `cloosed`
              }`,
            }}
            style={{ margin: `8px 0`, padding: `0` }}
          >
            <Button
              overrideClass={` accordion-item__line text-left Body accordion-item__title maax-font-weight-bold`}
              analytics_key={`${symbol}`}
              style={{ paddingTop: `14px` }}
              onClick={() => {
                setIsExpand(!isExpand)
              }}
            >
              <span
                className={`${classes.headingDisplay}`}
                style={{ display: !isExpand ? "block" : "none" }}
              >
                {contentPreviewCardsList.contentPreviewCardsList.heading}
              </span>
              <div
                className={`accordion-item__icon ${symbol}`}
                style={{ marginRight: `16px` }}
              >
                <ReactSVG
                  wrapper="span"
                  src={
                    !isExpand
                      ? getContentUrl(`/content/dam/wm/icons/plus-green.svg`)
                      : getContentUrl(`/content/dam/wm/icons/minus-green.svg`)
                  }
                />
              </div>
            </Button>
            <div
              {...{ className: `accordion-item__inner` }}
              style={{ background: !isExpand ? "" : "white" }}
            >
              <img
                style={{ marginBottom: `18px`, width: `100%` }}
                src={getContentUrl(
                  contentPreviewCardsList.contentPreviewCardsList.image,
                )}
                alt={
                  contentPreviewCardsList.contentPreviewCardsList.imageAltText
                }
              />
              <div
                className={`${
                  contentPreviewCardsList.contentPreviewCardsList.cardImage
                    ? "WmcontentcardwithImage"
                    : "WmcontentcardwithoutImage"
                }`}
                style={{ padding: `0 24px 15px` }}
              >
                <div className="maax-font-weight-bold cardItemtitle">
                  {contentPreviewCardsList.contentPreviewCardsList.date}
                </div>
                <Typography
                  className={`maax-font-weight-bold cardHeading ${classes.headingLink}`}
                  variant="h4"
                  style={{ color: "black" }}
                >
                  <Link
                    overrideClass="maax-font-weight-black cardHeading"
                    href={
                      contentPreviewCardsList.contentPreviewCardsList.ctaLink
                    }
                    isExternalLink={
                      contentPreviewCardsList.contentPreviewCardsList
                        .isExternalLink
                    }
                    style={{
                      marginTop: `0`,
                      textDecoration: `none`,
                      color: `${wmColor.greenHover}`,
                      fontSize: `unset`,
                      lineHeight: `unset`,
                    }}
                    analytics_key={
                      contentPreviewCardsList?.contentPreviewCardsList
                        ?.analyticsKey ||
                      `${contentPreviewCardsList.contentPreviewCardsList.cardHeading} ${contentPreviewCardsList.contentPreviewCardsList.cardCtaText} ${contentPreviewCardsList.contentPreviewCardsList.cardCtaURL}`
                    }
                  >
                    {contentPreviewCardsList.contentPreviewCardsList.heading}
                  </Link>
                </Typography>
                <div className="flex-grow-1 cardItemsubText maax-font-weight-regular">
                  {contentPreviewCardsList.contentPreviewCardsList.description.slice(
                    0,
                    200,
                  )}
                  <span className={`${classes.contentDescription}`}>...</span>
                </div>
                <div className="contentPreviewCta">
                  <Link
                    overrideClass="maax-font-weight-regular"
                    href={
                      contentPreviewCardsList.contentPreviewCardsList.ctaLink
                    }
                    isExternalLink={
                      contentPreviewCardsList.contentPreviewCardsList
                        .isExternalLink
                    }
                    style={{ color: `${wmColor.greenHover}` }}
                    analytics_key={
                      contentPreviewCardsList?.contentPreviewCardsList
                        ?.analyticsKey ||
                      `${contentPreviewCardsList.contentPreviewCardsList.cardHeading} ${contentPreviewCardsList.contentPreviewCardsList.cardCtaText} ${contentPreviewCardsList.contentPreviewCardsList.cardCtaURL}`
                    }
                  >
                    {
                      contentPreviewCardsList.contentPreviewCardsList
                        .ctaLinkText
                    }
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  )
}
export default ContentPreviewCard
